import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setUpperPopup } from "../store/reducers/general"
import { Loader } from "./loader"
let timeout

export function UpperPopup() {
    const dispatch = useDispatch()
    const { upperPopup } = useSelector((storeState) => storeState.general)

    useEffect(() => {
        if (timeout) clearTimeout(timeout)
        if (upperPopup) timeout = setTimeout(() => { dispatch(setUpperPopup('')) }, 4000)
    }, [upperPopup])

    if (!upperPopup) return <></>

    return <section className={'upper-popup' + ' upper-' + upperPopup}>
        {upperPopup === 'errorServer' && <p>שגיאה... אנא נסו שנית מאוחר יותר</p>}
        {upperPopup === 'errorOTP' && <p>שגיאה בקוד.</p>}
        {upperPopup === 'error-name' && <p>שם חייב להיות בין 2 ל-20 תווים.</p>}
        {upperPopup === 'empty-image' && <p>נא להעלות תמונה.</p>}
        {upperPopup === 'team-created' && <p>צוות נוצר בהצלחה.</p>}
        {upperPopup === 'empty-main-thumbnail' && <p>טאמבנייל ראשי לא יכול להיות ריק.</p>}
        {upperPopup === 'channelEdited' && <p>שם חדש נשמר בהצלחה.</p>}
        {upperPopup === 'no-roles-selected' && <p>אנא בחר תפקיד אחד לפחות</p>}
        {upperPopup === 'image-required' && <p>הסרטון חייב להכיל טאמבנייל</p>}
        {upperPopup === 'image-only' && <p>רק תמונות png,jpeg,webp ו-avif מותרות.</p>}
        {upperPopup === 'invite-sent' && <p>הזמנה נשלחה בהצלחה.</p>}
        {upperPopup === 'already-in-team' && <p>המייל כבר קיים בתוך הצוות.</p>}
        {upperPopup === 'thumbnails-edited' && <p>טאמבניילים נשמרו בהצלחה.</p>}
        {upperPopup === 'error-socket' && <p>נקטע החיבור לשרת. אנא רענן את הדף.</p>}
        {upperPopup === 'empty-title' && <p>כותרת מספר 1 לא יכולה להיות ריקה.</p>}
        {upperPopup === 'unauthenticated-socket' && <p>אינך מורשה לערוך דף זה</p>}
        {upperPopup === 'department-deleted' && <p>מחלקה נמחקה בהצלחה.</p>}
        {upperPopup === 'member-removed' && <p>חבר הוסר מהמחלקה בהצלחה.</p>}
        {upperPopup === 'members-added' && <p>חברים הוספו למחלקה בהצלחה.</p>}
        {upperPopup === 'invalid-link' && <p>הקישור לא תקין.</p>}
        {upperPopup === 'video-created' && <p>סרטון נוצר בהצלחה.</p>}
        {upperPopup === 'thumbnail-editor-only' && <p>עורך טאמבניילים לא יכול לקבל עוד תפקידים.</p>}
        {upperPopup === 'video-edited' && <p>סרטון נערך בהצלחה.</p>}
        {upperPopup === 'department-created' && <p>מחלקה נוצרה בהצלחה.</p>}
        {upperPopup === 'department-already-exists' && <p>קיימת כבר מחלקה בשם זה.</p>}
        {upperPopup === 'broken-link' && <p>הקישור לא תקין.</p>}
        {upperPopup === 'cant-invite-self' && <p>אי אפשר להזמין את עצמך.</p>}
        {upperPopup === 'invalid-phone' && <p>מספר טלפון אינו תקין</p>}
        {upperPopup === 'copied' && <p>הועתק.</p>}
        {upperPopup === 'fill-thumbnail-or-description' && <p>יש להעלות טאמבנייל או תיאור.</p>}
        {upperPopup === 'choose-role' && <p>אנא בחר תפקיד</p>}
        {upperPopup === 'error-loading-team-videos' && <p>אירעה שגיאה בטעינת המשימות של חברי הצוות.</p>}
        {upperPopup === 'loader' && <Loader />}
    </section>
}